module.exports = {
  loginRedirect: process.env.REACT_APP_LOGIN_REDIRECT,
  apiClinicalUrl: process.env.REACT_APP_API_CLINICAL_URL,
  apiReportUrl: process.env.REACT_APP_API_REPORT_URL,
  apiUrl: process.env.REACT_APP_API_URL,
  apiReservationUrl: process.env.REACT_APP_API_RESERVATION_URL,
  apiGeneralUrl: process.env.REACT_APP_API_GENERAL_URL,
  apiPaymentUrl: process.env.REACT_APP_API_PAYMENT_URL,
  apiForecastUrl: process.env.REACT_APP_API_FORECAST_URL,
  publicSiteUrlChile: process.env.REACT_APP_PUBLIC_SITE_CHILE,
  publicSiteUrlPeru: process.env.REACT_APP_PUBLIC_SITE_PERU,
  validatorUrl: process.env.REACT_APP_VALIDATOR_URL,
  wonderlicCode: process.env.REACT_APP_WONDERLIC_CODE,
  redirectedFromSage: process.env.REACT_APP_REDIRECT_FROM_SAGE,
  selfUrl: process.env.REACT_APP_SELF_URL,
  node_env: process.env.REACT_APP_NODE_ENV,
  apiDrug: process.env.REACT_APP_API_DRUG,
  socketServer: process.env.REACT_APP_SOCKET_SERVER,
  apiLaboratoryUrl: process.env.REACT_APP_API_LABORATORY_URL,
  apiLaboratoryBupaUrl: process.env.REACT_APP_API_LABORATORY_BUPA_URL,
  laboratoryBranches: process.env.REACT_APP_LABORATORY_BRANCHES,
  signerBranches: process.env.REACT_APP_SIGNER_BRANCHES,
  diabeticExam: process.env.REACT_APP_DIABETIC_EXAM,
  env: process.env.REACT_APP_ENV,
  signerType: process.env.REACT_APP_SIGNER_TYPE,
  apiSignerUrl: process.env.REACT_APP_API_SIGNER_URL,
  dicomUrl: process.env.REACT_APP_DICOM_URL,
  converterUrl: process.env.REACT_APP_API_CONVERTER_URL,
  apiRxUrl: process.env.REACT_APP_API_RX_URL,
  reportsCompanyIds: process.env.REACT_APP_REPORTS_COMPANY_IDS,
  apiQueueManagementUrl: process.env.REACT_APP_API_QUEUE_MANAGEMENT_URL,
  restrictedCompaniesSignIds: process.env.REACT_APP_RESTRICTED_COMPANIES_SIGN_IDS,
  newReportsDate: process.env.REACT_APP_NEW_REPORTS_DATE,
  doctorIaUrl: process.env.REACT_APP_DOCTOR_IA_URL,
  presignBatteries: process.env.REACT_APP_PRESIGN_BATTERIES,
  oldReportCompanyIds: process.env.REACT_APP_OLD_REPORT_COMPANY_IDS,
  apiLaboratoryBionetUrl: process.env.REACT_APP_API_LABORATORY_BIONET_URL,
  ecgProxyUrl: process.env.REACT_APP_ECG_PROXY_URL,
  campaingBranches: process.env.REACT_APP_CAMPAING_BRANCHES,
  apiOptometryBiarticUrl: process.env.REACT_APP_API_OPTOMETRY_BIARTIC_URL,
  apiEdxEcgUrl: process.env.REACT_APP_API_EDX_ECG_URL,
  apiLaboratorySofsaludUrl: process.env.REACT_APP_API_LABORATORY_SOFSALUD_URL,
};

